import { connect } from 'react-redux';
import ProfileSettings from '../components/ProfileSettings';

const mapStateToProps = ({ user, ui }) => ({
  userData: user.userData,
  invertedTheme: ui.invertedTheme
});

export default connect(mapStateToProps)(ProfileSettings);



// WEBPACK FOOTER //
// ./src/containers/ProfileSettingsContainer.js